/** 登录从本站后端开始；账号中心端点、Client ID 和 Secret 仅由后端处理。 */
export function buildSsoLoginUrl(nextPath = '/') {
  return '/api/auth/login/?next=' + encodeURIComponent(safeNextPath(nextPath))
}

/** 与后端一致，只允许站内业务地址，避免外跳或登录回环。 */
export function safeNextPath(value = '/') {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') ||
      value.includes('\\') || Array.from(value).some(char => char.charCodeAt(0) < 32) ||
      value.startsWith('/login') || value.startsWith('/api/auth/')) return '/'
  return value
}
